module.exports = __webpack_public_path__ + "img/p.a6ee7814.jpg";